"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group 314"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.951903 9.08472C1.5614 8.47522 2.38805 8.13281 3.25 8.13281H8.45C9.31195 8.13281 10.1386 8.47522 10.7481 9.08472C11.3576 9.69421 11.7 10.5209 11.7 11.3828V12.6828C11.7 13.0418 11.409 13.3328 11.05 13.3328C10.691 13.3328 10.4 13.0418 10.4 12.6828V11.3828C10.4 10.8656 10.1946 10.3697 9.82886 10.004C9.46316 9.63826 8.96717 9.43281 8.45 9.43281H3.25C2.73283 9.43281 2.23684 9.63826 1.87114 10.004C1.50545 10.3697 1.3 10.8656 1.3 11.3828V12.6828C1.3 13.0418 1.00899 13.3328 0.65 13.3328C0.291015 13.3328 0 13.0418 0 12.6828V11.3828C0 10.5209 0.34241 9.69421 0.951903 9.08472Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_2",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.85059 1.63301C4.77363 1.63301 3.90059 2.50605 3.90059 3.58301C3.90059 4.65996 4.77363 5.53301 5.85059 5.53301C6.92754 5.53301 7.80059 4.65996 7.80059 3.58301C7.80059 2.50605 6.92754 1.63301 5.85059 1.63301ZM2.60059 3.58301C2.60059 1.78808 4.05566 0.333008 5.85059 0.333008C7.64551 0.333008 9.10059 1.78808 9.10059 3.58301C9.10059 5.37793 7.64551 6.83301 5.85059 6.83301C4.05566 6.83301 2.60059 5.37793 2.60059 3.58301Z",
    fill: fill
  })));
};

exports["default"] = _default;